module.exports = __webpack_public_path__ + "img/ic-menu-white.7e963782.svg";